import {Text} from '~/components/text'
import {InnerAvatar} from '../inner_avatar'

export const InitialsAvatar = ({initials, ...rest}) => {
	return (
		<InnerAvatar colorSet={undefined} {...rest}>
			<Text noTextSelect semiBold>
				{initials}
			</Text>
		</InnerAvatar>
	)
}
